const StorageHelper = {
  getItem(value) {
    if (this.isReqTokenPresent()) return sessionStorage.getItem(value);
    return localStorage.getItem(value);
  },

  setItem(key, value) {
    if (this.isReqTokenPresent()) sessionStorage.setItem(key, value);
    else localStorage.setItem(key, value);
  },

  removeItem(value) {
    if (this.isReqTokenPresent()) sessionStorage.removeItem(value);
    else localStorage.removeItem(value);
  },

  clear() {
    if (this.isReqTokenPresent()) sessionStorage.clear();
    else localStorage.clear();
  },

  isReqTokenPresent() {
    return sessionStorage.getItem("req_token") ? true : false;
  },
};
export default StorageHelper;
